import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { disableWorkspaceCode } from '../../../../api/workspaces/invite/disableWorkspaceCode';

export function useDisableWorkspaceCode() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: disableWorkspaceCode,
    onSettled: (_data, _error, { workspaceId, workspaceRole }) => {
      queryClient.invalidateQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
      // Also refresh the per-role status badges so disabling a link flips its
      // dropdown badge to "No invite".
      return queryClient.invalidateQueries(
        workspaceKeys.codeStatuses(workspaceId)
      );
    },
    onMutate: ({ workspaceId, workspaceRole }) => {
      queryClient.removeQueries(
        workspaceKeys.codeByWorkspaceRole({ workspaceId, workspaceRole })
      );
    },
    onError: () => {
      //console.log('error');
    },
  });
}
